import makeClasses from './NoveltyCard.style';

import type { HTMLAttributes } from 'react';
import type { MozartNovelty } from 'features/mozart-notifications/domain';

export function NoveltyCard(props: Props) {
  const { novelty, ...restProps } = props;

  const _classes = makeClasses();

  return (
    <article data-seen={novelty.seen} className={_classes.card} {...restProps}>
      <header className={_classes.header}>
        <h3 className={_classes.title}>{novelty.title}</h3>
        <div className={_classes.checkMark}>{novelty.seen}</div>
      </header>

      <main>
        <p className={_classes.description}>{novelty.description}</p>
      </main>

      <footer>
        <p className={_classes.dateTime}>{novelty.createdAt}</p>
      </footer>
    </article>
  );
}

interface Props extends HTMLAttributes<HTMLElement> {
  novelty: MozartNovelty;
}
